import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetPunchoutIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";

type HandlerType = Handler<GetPunchoutIdentityApiParameter>;

export const DispatchUpdateLoadParameter: HandlerType = props => {
    props.dispatch({
        type: "Pages/PunchoutIdentity/UpdateLoadParameter" as any,
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateLoadParameter];

const updateLoadParameter = createHandlerChainRunner(chain, "UpdateLoadParameter");
export default updateLoadParameter;
